<template>
    <div>
        <v-layout wrap justify-space-between align-center
                  mb-4
        >
            <v-flex md5 sm6 xs12>
                <v-select
                    v-model="theme"
                    :items="themes"
                    solo
                    append-icon=""
                    :label="$t('Все предложения')"
                    class="input"
                    @change="CLEAR_PAGES()"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
            <v-flex md3 sm5 xs12
                    :class="{'mt-3': $vuetify.breakpoint.xs}"
            >
                <v-select
                    :items="[$t('Сначала новые'),$t('Сначала старые')]"
                    solo
                    append-icon=""
                    :label="$t('Сначала новые')"
                    class="input"
                    @change="sorting_by_date($event)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
            <buttonRed class="md3 sm7 xs12 flex" :class="{'mt-3': $vuetify.breakpoint.mdAndDown}" @click.native="OPEN_MODAL('suggest_news_modal')">{{$t("Предложить новость/мероприятие")}}</buttonRed>
        </v-layout>
        <v-layout class="pb-5 column">
            <template v-if="paginated.length > 0">
                <div v-for="(suggestion, i) in paginated" :key="i">
                    <suggestionBlock class="mb-4" :content="suggestion"
                                     :class="{'background-light': !(i%2)}" :my_ideas="true"
                    />
                </div>
            </template>
            <div v-else>{{$t("По запросу ничего не найдено")}}</div>
        </v-layout>
        <v-layout v-if="filtered_by_theme.length>10" justify-space-between align-center
                  wrap
        >
            <buttonRed class="md3 sm7 xs12 flex" :class="{'mb-3': $vuetify.breakpoint.mdAndDown}" @click.native="OPEN_MODAL('suggest_news_modal')">{{$t("Предложить новость/мероприятие")}}</buttonRed>
            <v-flex md5 sm7 xs12
                    mb-4
            >
                <div class="text-xs-center">
                    <v-pagination
                        v-model="page"
                        :length="Math.ceil(filtered_by_theme.length / selected_number)"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm5 xs12
                    mb-4
            >
                <v-select
                    :items="$vuetify.breakpoint.mdAndUp ? [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50'),$t('Показывать по 100')]
                    : [$t('Показывать по 10'),$t('Показывать по 25'),$t('Показывать по 50')]"
                    solo
                    append-icon=""
                    :label="$t('Показывать по 10')"
                    class="input"
                    @change="show_number($event, 10)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import suggestionBlock from './suggestion_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    suggestionBlock,
    buttonRed,
  },
  computed: {
    ...mapGetters('activity/suggestions', [
      'suggestions',
      'selected_page',
      'selected_number',
      'paginated',
      'search_string',
      'filtered_by_theme',
    ]),
    ...mapGetters('activity', [
      'themes',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
    theme: {
      get() {
        return this.selected_theme;
      },
      set($event) {
        return this.SET_SELECTED_THEME($event);
      },
    },
  },
  methods: {
    ...mapMutations('activity/suggestions', [
      'SET_SELECTED_THEME',
      'SET_SELECTED_PAGE',
      'SHOW_NUMBER',
      'CLEAR_PAGES',
      'SORT_BY_DATE',
      'SEARCH_STRING',
    ]),
    ...mapMutations('news_main', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('activity/suggestions', [
      'show_number',
      'sorting_by_date',
      'get_activity',
    ]),
  },

};
</script>

<style>

</style>
